import * as Yup from 'yup';
import type { Asserts } from 'yup';
import slugify from 'slugify';
import { TransformXTicketFragment } from '../dato/gql/generated';

export const linkedInAuthState = 'pgoi2SDFj09js3SAGo5';
export const linkedinRedirectUri = process.env.NEXT_PUBLIC_TRANSFORM_X_LINKEDIN_REDIRECT_URI;
export const linkedInAuthUri = `https://www.linkedin.com/oauth/v2/authorization?client_id=86uysx1g2lvxxm&response_type=code&redirect_uri=${linkedinRedirectUri}&scope=r_liteprofile%20r_emailaddress&state=${linkedInAuthState}`;

export const transformXOriginURL = 'https://scale.com';

export const transformXLocalStorageKey = 'transformx-ticket-slug';

export const getSlug = (firstName: string, lastName: string) =>
  slugify(`${firstName}-${lastName}`, { lower: true, strict: true });

export const registrantSchema = Yup.object({
  firstName: Yup.string().defined(),
  lastName: Yup.string().defined(),
  isLinkedInRegistrant: Yup.boolean().defined(),
  companyName: Yup.string().nullable(),
  jobTitle: Yup.string().nullable(),
  workEmail: Yup.string().nullable(),
  imageId: Yup.string().nullable(),
  imageUrl: Yup.string().nullable()
});

export type Registrant = Asserts<typeof registrantSchema>;

export function ticketIsReady(ticket: TransformXTicketFragment) {
  return {
    fully: !!ticket.ogImage,
    partially: !!ticket.ogImage || (ticket.avatarUploadId ? !!ticket.image : true)
  };
}
